import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';

export const SCHEDULE_TYPE_CELL_PARAM_TEMPLATE_UPDATED = gql`
  subscription scheduleTypeCellParamTemplateUpdated {
    scheduleTypeCellParamTemplateUpdated {
      scheduleTypeCellParamTemplate {
        scheduleTypeCellParamTemplateId
        templateName
        activeYN
        scheduleTypeId
        seasonalityTypeId
        monthsNo
        isEditable
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;
